/* @flow */

import { connect } from 'react-redux';
import React from 'react';

import { Button, PageContainer } from '@sonyged/ext-proc';

import { type ConnectionErrorProps, hideError, retryAction } from '../redux/reducer/meta';
import type { Dispatch } from '../redux/types';
import ConnectionErrorIllustration from '../../assets/images/common/error_network@3x.png';

type Props = {
  ...ConnectionErrorProps,
  dispatch: Dispatch,
};

const ConnectionErrorPage = ({ dispatch, ...props }: Props) => {
  const retryHandle = () => {
    dispatch(hideError());
    for (const action of props.actions) {
      dispatch(retryAction(action));
    }
  };
  return (
    <div className="proc-errorPage">
      <PageContainer.normal className="proc-errorPage-container">
        <div className="proc-errorPage-body proc-errorContent">
          <img
            className="proc-errorContent-illustration"
            alt="connection error illustration"
            src={ConnectionErrorIllustration}
          />
          <h2 className="proc-errorContent-title">つうしん できません</h2>
          <p className="proc-errorContent-text">
            でんぱの よいところで
            <br />
            もういちど ためしてね。
          </p>
          <p className="proc-errorContent-postscript">※うまく いかない ときは、 おとなの ひとに きいてね。</p>
        </div>
        <div className="proc-errorPage-footer">
          <Button.attention className="w100" onClick={retryHandle}>
            もう いちど ためす
          </Button.attention>
        </div>
      </PageContainer.normal>
    </div>
  );
};

// $FlowFixMe
export default connect()(ConnectionErrorPage);
